import { PaymentMethodOption } from '@porterin/component-library/src/feature-components/payment-method-modal/PaymentMethodModal';

import { PaymentMethod } from '../../domain/entities/PaymentMethod';

export const COOKIE_KEYS = {
  AUTH_TOKEN: 'auth-token',
  MOBILE: 'mobile',
  VISITOR_ID: 'visitor_id',
  WEB_TRACKING_D: 'web_tracking_id',
};

export const DEFAULT_VALUES = {
  DEFAULT_GEO_REGION_ID: 0,
  DEFAULT_REDIRECT_DELAY_AFTER_CREATE_TRIP: 500,
};

// India goods types
export const defaultGoodsIndia = [
  {
    id: 1086,
    name: 'Timbers / Plywoods / Papers',
  },
  {
    id: 1073,
    name: 'Electronics / Consumer Durables',
  },
  {
    id: 1077,
    name: 'General Goods',
  },
  {
    id: 1067,
    name: 'Building Materials',
  },
  {
    id: 1068,
    name: 'Event Management / Hospitality',
  },
  {
    id: 1081,
    name: 'Machines / Equipments / Spare Parts',
  },
  {
    id: 1085,
    name: 'Textiles / Garments / Fashion Accessories',
  },
  {
    id: 1076,
    name: 'Furnitures / Home Furnishings',
  },
  {
    id: 1079,
    name: 'House Shifting / Packers and Movers',
  },
  {
    id: 1069,
    name: 'Ceramic / Sanitary Wares',
  },
  {
    id: 1084,
    name: 'Rubber Products',
  },
  {
    id: 1070,
    name: 'Paints / Chemicals (Non-Hazardous)',
  },
  {
    id: 1075,
    name: 'Homemade / Prepared Fresh Items',
  },
  {
    id: 1082,
    name: 'Pharmaceutical / Healthcare Products',
  },
  {
    id: 1074,
    name: 'FMCG Products',
  },
  {
    id: 1083,
    name: 'Plastic Products',
  },
  {
    id: 1087,
    name: 'Stationery / Gifts / Toys',
  },
  {
    id: 1078,
    name: 'Hardwares',
  },
  {
    id: 1072,
    name: 'Electrical',
  },
];

// International goods types
export const defaultGoodsInternational = [
  {
    id: 52,
    name: 'Timber / Plywood / Laminate',
  },
  {
    id: 53,
    name: 'Electrical / Electronics / Home Appliances',
  },
  {
    id: 54,
    name: 'Books / Stationery / Toys / Gifts',
  },
  {
    id: 55,
    name: 'Building / Construction',
  },
  {
    id: 56,
    name: 'Catering / Restaurant / Event Management',
  },
  {
    id: 57,
    name: 'Ceramics / Sanitary / Hardware',
  },
  {
    id: 58,
    name: 'Chemicals / Paints',
  },
  {
    id: 59,
    name: 'FMCG / Food Products',
  },
  {
    id: 60,
    name: 'Furniture / Home Furnishing',
  },
  {
    id: 61,
    name: 'House Shifting',
  },
  {
    id: 62,
    name: 'Logistics service provider / Packers and Movers',
  },
  {
    id: 63,
    name: 'Machines / Equipments / Spare Parts / Metals',
  },
  {
    id: 64,
    name: 'Paper / Packaging / Printed Material',
  },
  {
    id: 65,
    name: 'Perishable food items',
  },
  {
    id: 66,
    name: 'Pharmacy / Medical / Healthcare / Fitness Equipment',
  },
  {
    id: 67,
    name: 'Plastic / Rubber',
  },
  {
    id: 68,
    name: 'Textile / Garments / Fashion Accessories',
  },
];

// Legacy export for backward compatibility
export const defaultGoods = defaultGoodsIndia;

// Default goods type by country
export const defaultGoodsTypeIndia = {
  id: 1086,
  name: 'Timbers / Plywoods / Papers',
};

export const defaultGoodsTypeInternational = {
  id: 52,
  name: 'Timber / Plywood / Laminate',
};

// Legacy export for backward compatibility
export const defaultGoodsType = defaultGoodsTypeIndia;

export const OrderReviewLabels = {
  emptyPredictionsText: 'Start searching for places',
  emptyPredictionsSubtext:
    'Search for nearby landmarks, building name, area or street name',
  predictionsTitle: 'Search Results',
  agreedDocs: {
    prefix1: 'By booking, you agree to our new ',
    prefix2: 'Terms & Conditions ',
    prefix3: ' and ',
    prefix4: 'Privacy Policy',
  },
  editBookingForm: {
    housePlaceholder: 'House / Apartment (optional)',
    namePlaceholder: 'Name',
    mobilePlaceholder: 'Mobile',
  },
  fareBreakupTitle: 'Fare Breakup',
  fareBreakupModalClose: 'Okay',
  addressInputPlaceholder: 'Enter address',
  waypointPrefix: 'Where is your',
  selectGoodsTitle: 'Select Goods Type',
  confirm: 'Confirm and Proceed',
  vehicleDetailsModalClose: 'Done',
  addressDetailsSectionTitle: 'Address Details',
  fareBreakdownSectionTitle: 'Fare Breakdown',
  selectVehicleSectionTitle: 'Select Vehicle',
  orderSuccessText: 'Order Placed!',
  editAction: 'Edit',
  editText: 'Edit',
  viewBreakupText: 'View Breakup',
  mobileHeaderTitle: 'Review Order Summary',
  etaAwayText: 'away',
  currencySymbol: '₹',
  unitText: 'Kg',
  changeText: 'Change',
  goodsTypeText: 'Goods Type',
  goodsTypeDefaultSelectText: 'Select a Goods Type',
  bookCtaText: 'Book',
  bookNowCtaText: 'Book Now',
  paymentMethodText: 'Payment Method',
  paymentMethodSubText: 'Select Payment Method',
  cashText: 'Cash',
  porterText: 'Porter',
  businessWalletText: 'Business Wallet',
  editPickupHeaderText: 'Edit Pickup location',
  editDropHeaderText: 'Edit Drop location',
  pickupAddressPlaceholder: 'Enter Pickup Address',
  dropAddressPlaceholder: 'Enter Drop Address',
  tripFareText: 'Trip Fare',
  tripFareSubText: '(incl. Toll, if applicable)',
  netFareText: 'Net Fare',
  amountPayableText: 'Amount Payable',
  amountPaidText: 'Amount paid',
  previousDuesText: 'Previous Dues',
  porterGoldFeeText: 'Porter Gold Fee',
  porterCreditsAppliedText: 'Porter Credits Applied',
};

// TODO: consume from CMS
export const OrderReviewAssets = {
  mapPin: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/map_pin_cc7d3d58de/map_pin_cc7d3d58de.svg',
    alt: 'Map Pin',
  },
  searchIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/search_07259261cb/search_07259261cb.svg',
    alt: 'Search Icon',
  },
  crossIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/cross_icon_grey_a85a70f29a/cross_icon_grey_a85a70f29a.svg',
    alt: 'Cross Icon',
  },
  crossIconBlack: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/cross_black_3f63a93cc1/cross_black_3f63a93cc1.svg',
    alt: 'Cross Icon',
  },
  dropIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/drop_address_e0335d60b3/drop_address_e0335d60b3.svg',
    alt: 'Drop Pin',
  },
  arrowLeftIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/arrow_left_default_7016da1f3f/arrow_left_default_7016da1f3f.svg',
    alt: 'Arrow Left',
  },
  clearInputIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/clear_input_cross_grey_8d880447b1/clear_input_cross_grey_8d880447b1.svg',
    alt: 'Clear',
  },
  etaPillLottie:
    'https://dom-content-vault-prod-cdn-assets.porter.in/Eta_Pill_4366b62ba0/Eta_Pill_4366b62ba0.json',
  discountTag: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/discount_tag_660d49611b/discount_tag_660d49611b.svg',
    alt: 'Discount Tag Icon',
  },
  etaClockIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/eta_clock_icon_7c9439ceff/eta_clock_icon_7c9439ceff.svg',
    alt: 'ETA Clock Icon',
  },
  goodsType: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/goods_type_43a85b82b2/goods_type_43a85b82b2.svg',
    alt: 'goods-type',
  },
  paymentCash: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/payment_cash_0eac7e125c/payment_cash_0eac7e125c.svg',
    alt: 'Payment Cash Icon',
  },
  paymentBusinessWallet: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/Business_Wallet_46b40a3e66/Business_Wallet_46b40a3e66.svg',
    alt: 'Payment Business Wallet Icon',
  },
  porterGoldTag: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/porter_gold_tag_51e5c723a9/porter_gold_tag_51e5c723a9.svg',
    alt: 'Porter Gold Icon',
  },
  accordionArrow: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/accordion_arrow_fc9262f0d8/accordion_arrow_fc9262f0d8.svg',
    alt: 'accordion-arrow',
  },
  createTripSuccess: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/Tick_Circle_3a29ab4167/Tick_Circle_3a29ab4167.svg',
    alt: 'order-success',
  },
};

// Base(incomplete) payment options. To be supplemented and overridden by order review lifecycle flows to populate payment options data.
export const paymentOptionsMap: {
  [key in PaymentMethod]: PaymentMethodOption;
} = {
  cash: {
    id: 'cash',
    label: 'Cash',
    shouldShow: true,
    icon: {
      src: OrderReviewAssets.paymentCash.src,
      alt: OrderReviewAssets.paymentCash.alt,
    },
  },
  business_wallet: {
    id: 'business_wallet',
    label: '',
    subLabel: 'Business Wallet',
    shouldShow: false,
    icon: {
      src: OrderReviewAssets.paymentBusinessWallet.src,
      alt: OrderReviewAssets.paymentBusinessWallet.alt,
    },
  },
} as const;

export const paymentModalStore = {
  title: 'Payment Method',
  confirmText: 'Set Payment Method',
  closeIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/cross_black_3f63a93cc1/cross_black_3f63a93cc1.svg',
    alt: 'Close Icon',
  },
} as const;

export const orderRemarksModalStore = {
  closeIcon: {
    src: OrderReviewAssets.crossIconBlack.src,
    alt: OrderReviewAssets.crossIconBlack.alt,
  },
  placeholder: '',
  title: 'What is this trip for?',
  subtitle: 'Please fill the trip info for identification',
} as const;
